import { render, staticRenderFns } from "./TableTr.vue?vue&type=template&id=058b9a7c&scoped=true"
import script from "./TableTr.vue?vue&type=script&lang=js"
export * from "./TableTr.vue?vue&type=script&lang=js"
import style0 from "./TableTr.vue?vue&type=style&index=0&id=058b9a7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058b9a7c",
  null
  
)

export default component.exports